import { render } from "./SocialBox.vue?vue&type=template&id=b4b6270a&scoped=true"
import script from "./SocialBox.vue?vue&type=script&lang=js"
export * from "./SocialBox.vue?vue&type=script&lang=js"

import "./SocialBox.vue?vue&type=style&index=0&id=b4b6270a&scoped=true&lang=css"

import exportComponent from "/Users/brianng/Documents/GitHub/SupaFoundationWeb2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b6270a"]])

export default __exports__